import { AutoGraph, Grid4x4Sharp } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import GetAppIcon from "@mui/icons-material/GetApp";
import { CSVLink } from "react-csv";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  Pagination,
  TableRow,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getRequest, postRequest } from "../../globalhelper/helper";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const pieOptions = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 15,
        font: { size: 13 },
        padding: 25
      }
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.label || "";
          if (label) {
            label += ": ";
          }
          if (context.raw !== null) {
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((context.raw / total) * 100).toFixed(1) + "%";
            label += `${percentage} - ${context.raw} count${context.raw > 1 ? 's' : ''}`;
          }
          return label;
        },
      },
    },
    datalabels: {
      display: function (context) {
        const dataset = context.dataset;
        const total = dataset.data.reduce((a, b) => a + b, 0);
        const value = dataset.data[context.dataIndex];
        const percentage = (value / total) * 100;
        return percentage > 3;
      },
      formatter: (value, ctx) => {
        if (!value) return null;
        const total = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
        const percentage = ((value / total) * 100).toFixed(1) + "%";
        return `${percentage} - ${value}`;
      },
      color: '#333',
      anchor: 'end',
      align: 'end',
      offset: 10,
      font: {
        weight: 'bold',
        size: 14
      }
    }
  },
  layout: {
    padding: {
      top: 30,
      bottom: 30,
      left: 80,
      right: 80
    }
  }
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const {
    count,
    page,
    rowsPerPage,
    onPageChange
  } = props;
  const [previousCount, setPreviousCount] = useState(count);
  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0);
    }
    setPreviousCount(count);
  }, [count, page, onPageChange, previousCount]);
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return <Box sx={{
    flexShrink: 0,
    ml: 2.5
  }}>
    <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
      {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
    </IconButton>
    <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
      {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
    </IconButton>
    <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
      {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
    </IconButton>
    <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
      {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
    </IconButton>
  </Box>;
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
export default function ARReconcilationReport() {
  const [rows, setRows] = useState([]);
  const [Companies, setCompanies] = useState([]);
  const [Company, setCompany] = useState("");
  const [From, setFrom] = useState("");
  const [To, setTo] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [InputTheme, setInputTheme] = useState("");
  const [matchCode, setmatchCode] = useState("");
  const [bankRef, setBankRef] = useState("");
  const [ReceiptNo, setReceiptNo] = useState([]);
  const [ReceiptNos, setReceiptNos] = useState([]);
  const [InputThemes, setInputThemes] = useState([]);
  const [matchCodes, setMatchCodes] = useState([]);
  const [bankRefs, setBankRefs] = useState([]);
  const [viewMode, setViewMode] = useState("grid");
  const [themeChartData, setThemeChartData] = useState(null);
  const [matchCodeChartData, setMatchCodeChartData] = useState(null);
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length) : 0;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const updateChartData = data => {
    const inputThemeCountMap = data.reduce((acc, item) => {
      const themeName = item["Input Theme Name"];
      if (themeName) {
        acc[themeName] = (acc[themeName] || 0) + 1;
      }
      return acc;
    }, {});
    const matchCodeCountMap = data.reduce((acc, item) => {
      const matchCode = item["Match Code"];
      if (matchCode) {
        acc[matchCode] = (acc[matchCode] || 0) + 1;
      }
      return acc;
    }, {});
    const themeData = {
      labels: Object.keys(inputThemeCountMap),
      datasets: [{
        label: "Input Theme Count",
        data: Object.values(inputThemeCountMap),
        backgroundColor: Object.keys(inputThemeCountMap).map(theme => `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.5)`),
        borderColor: Object.keys(inputThemeCountMap).map(theme => `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`)
      }]
    };
    const matchCodeData = {
      labels: Object.keys(matchCodeCountMap),
      datasets: [{
        label: "Match Code Count",
        data: Object.values(matchCodeCountMap),
        backgroundColor: Object.keys(matchCodeCountMap).map(code => `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.5)`),
        borderColor: Object.keys(matchCodeCountMap).map(code => `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`)
      }]
    };
    setMatchCodeChartData(matchCodeData);
    setThemeChartData(themeData);
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(({
      res
    }) => {
      if (res.data.length === 1) {
        setCompany(res.data[0]);
      }
      setCompanies((res.data || []).sort((a, b) => (a.orgname || "").localeCompare(b.orgname || "")));
    }).catch(err => console.log(err));
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFrom(firstDay);
    setTo(lastDay);
  }, []);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    dispatch(showLoader());
    postRequest("api/tds/getARReconcilationReport").then(response => {
      setRows(response.res.data);
      setFilteredData(response.res.data);
      const responseData = response.res.data;
      if (response.res.data.length > 0) {
        updateChartData(responseData);
        setInputThemes(Array.from(new Set(responseData.map(item => item?.["Input Theme Name"]))).sort());
        setMatchCodes(Array.from(new Set(responseData.map(item => item?.["Match Code"]))).sort());
        setBankRefs(Array.from(new Set(responseData.map(item => item?.["Bank Ref"]))).sort());
        setReceiptNos(Array.from(new Set(responseData.map(item => item?.["Receipt No"]))).sort());
      }
    }).catch(error => {
      console.error("Error fetching AR Reconcilation Report Data:", error);
    }).finally(() => {
      dispatch(hideLoader());
    });
  };
  useEffect(() => {
    if (InputTheme === "" && matchCode === "" && bankRef === "" && ReceiptNo === "" || !InputTheme && !matchCode && !bankRef && !ReceiptNo) {
      setFilteredData(rows);
      updateChartData(rows);
    } else {
      handleFilterChange(InputTheme, matchCode, bankRef, ReceiptNo);
    }
  }, [InputTheme, matchCode, bankRef, ReceiptNo]);
  const handleFilterChange = (InputTheme, matchCode, bankRef, ReceiptNo) => {
    const filteredData = rows.filter(item => item?.["Input Theme Name"] === InputTheme || item?.["Match Code"] === matchCode || item?.["Bank Ref"] === bankRef || item?.["Receipt No"] === ReceiptNo);
    setFilteredData(filteredData);
    updateChartData(filteredData);
  };
  const handleReset = () => {
    setCompany("");
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFrom(firstDay);
    setTo(lastDay);
    setRows([]);
    setInputThemes([]);
    setMatchCodes([]);
    setBankRefs([]);
    setReceiptNos("");
    setInputTheme("");
    setmatchCode("");
    setBankRef("");
    setReceiptNo("");
  };
  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
    }
  };
  return <>
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
        <Typography variant="h6">Reconcilation Upload</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container gap={2}>
          <Grid item xs={1} sm={2} md={3}>
            <Autocomplete size="small" fullWidth value={Company || null} options={Companies} getOptionLabel={option => option?.orgname || ""} isOptionEqualToValue={(option, value) => option.orgid === value?.orgid} onChange={(event, newValue) => setCompany(newValue)} renderInput={params => <TextField {...params} label="Company" variant="outlined" name="Company" />} />
          </Grid>
          <Grid item xs={1} sm={2} md={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="ForPrdFrom" value={From} views={["day", "month", "year"]} onChange={newValue => {
                setFrom(newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={1} sm={2} md={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="ForPrdTo" value={To} views={["day", "month", "year"]} onChange={newValue => {
                setTo(newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={1}>
            <Button fullWidth variant="outlined" color="success" onClick={handleSubmit}>
              Submit
            </Button>
          </Grid>
          <Grid item xs={1}>
            <Button onClick={handleReset} fullWidth variant="outlined" color="error">
              Reset
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>

    {rows.length > 0 && (
      <>
        {viewMode === "grid" && <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Filter Report</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={1} sm={2} md={3}>
                <Autocomplete options={InputThemes || []} value={InputTheme || null} getOptionLabel={option => typeof option === "string" ? option : option?.themeName || ""} onChange={(e, newValue) => {
                  setInputTheme(newValue);
                  setBankRef("");
                  setmatchCode("");
                  setReceiptNo("");
                }} fullWidth renderInput={params => <TextField {...params} label="Input Theme" variant="outlined" size="small" />} />
              </Grid>
              <Grid item xs={1} sm={2} md={3}>
                <Autocomplete options={bankRefs || []} value={bankRef || null} getOptionLabel={option => typeof option === "string" ? option : option?.refNumber || ""} onChange={(e, newValue) => {
                  setInputTheme("");
                  setBankRef(newValue);
                  setmatchCode("");
                  setReceiptNo("");
                }} fullWidth renderInput={params => <TextField {...params} label="Reference Number" variant="outlined" size="small" />} />
              </Grid>
              <Grid item xs={1} sm={2} md={3}>
                <Autocomplete options={matchCodes || []} value={matchCode || null} getOptionLabel={option => typeof option === "string" ? option : option?.matchCode || ""} onChange={(e, newValue) => {
                  setInputTheme("");
                  setBankRef("");
                  setmatchCode(newValue);
                  setReceiptNo("");
                }} fullWidth renderInput={params => <TextField {...params} label="Match Code" variant="outlined" size="small" />} />
              </Grid>
              <Grid item xs={1} sm={2} md={3}>
                <Autocomplete options={ReceiptNos || []} value={ReceiptNo || null} getOptionLabel={option => typeof option === "string" ? option : option?.receiptNo || ""} onChange={(e, newValue) => {
                  setInputTheme("");
                  setBankRef("");
                  setmatchCode("");
                  setReceiptNo(newValue);
                }} fullWidth renderInput={params => <TextField {...params} label="Receipt No" variant="outlined" size="small" />} />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>}
        <Box align="right" sx={{
          m: 2,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "row",
          gap: 2
        }}>
          {viewMode === "grid" && <Pagination count={Math.ceil(filteredData.length / rowsPerPage)} page={page + 1} onChange={(event, newPage) => {
            handleChangePage(event, newPage - 1);
          }} variant="outlined" shape="rounded" showFirstButton showLastButton />}
          &nbsp;
          <CSVLink size="sm" filename={`ARReconcilationReport_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`} data={filteredData}>
            <Button variant="contained" color="success">
              <GetAppIcon />
            </Button>
          </CSVLink>
          <ToggleButtonGroup
            value={viewMode}
            onChange={handleViewModeChange}
            color="primary"
            exclusive
            aria-label="View Mode"
          >
            <ToggleButton value="grid">
              <Grid4x4Sharp />
            </ToggleButton>
            <ToggleButton value="chart">
              <AutoGraph />
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {viewMode === "grid" && (
          <>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 500 }}
                aria-label="custom pagination table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Input Theme Name</TableCell>
                    <TableCell>Match Code</TableCell>
                    <TableCell>Bank Ref</TableCell>
                    <TableCell>Receipt No</TableCell>
                    <TableCell>Total Amount</TableCell>
                    <TableCell>Transaction Amount</TableCell>
                    <TableCell>Transaction Number</TableCell>
                    <TableCell>Amount Difference</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? filteredData.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    : filteredData
                  ).map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row?.["Input Theme Name"]}</TableCell>
                      <TableCell>{row?.["Match Code"]}</TableCell>
                      <TableCell>{row?.["Bank Ref"]}</TableCell>
                      <TableCell>{row?.["Receipt No"]}</TableCell>
                      <TableCell>{row?.["Total Amount"]}</TableCell>
                      <TableCell>{row?.["Transaction Amount"]}</TableCell>
                      <TableCell>{row?.["Transaction Number"]}</TableCell>
                      <TableCell>{row?.["Amount Difference"]}</TableCell>
                    </TableRow>
                  ))}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        {viewMode === "chart" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "nowrap",
              gap: 4,
              mt: 4,
              overflowX: "auto",
              pb: 2,
            }}
          >
            <Box sx={{
              flex: 1, minWidth: "500px", textAlign: "center"
            }}>
              {themeChartData && (
                <>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>Input Theme Based</Typography>
                  <Box sx={{ height: '550px' }}>
                    <Pie data={themeChartData} options={pieOptions} plugins={[ChartDataLabels]} redraw updateMode="show" />
                  </Box>
                </>
              )}
            </Box>
            <Box sx={{
              flex: 1, minWidth: "500px", textAlign: "center"
            }}>
              {matchCodeChartData && (
                <>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>Match Code Based</Typography>
                  <Box sx={{ height: '550px' }}>
                    <Pie data={matchCodeChartData} options={pieOptions} plugins={[ChartDataLabels]} redraw updateMode="show" />
                  </Box>
                </>
              )}
            </Box>
          </Box>
        )}
      </>
    )}
  </>
}